const SAMPLE_PDF_PATH = '/einwert_Muster_Folgegutachten.pdf'
const SAMPLE_PDF_FILENAME = 'einwert_Muster_Folgegutachten.pdf'

export async function loadSamplePdfFile(): Promise<File> {
    const response = await fetch(SAMPLE_PDF_PATH)

    if (!response.ok) {
        throw new Error('Sample PDF could not be loaded')
    }

    const blob = await response.blob()
    return new File([blob], SAMPLE_PDF_FILENAME, { type: 'application/pdf' })
}
